import { queryOptions, useQuery } from '@tanstack/react-query';

import type { JobPost } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { findDataInQueryCache } from '../utils';
import { jobPostSchema } from './schemas';

export const jobPostQueryOptions = (jobPostId: number) => {
  const cachedJobPost = findDataInQueryCache<JobPost>(
    [...QueryKeys.jobPosts.index.root, 'metadata'],
    (jobPost) => jobPost.id === jobPostId,
  );

  return queryOptions({
    queryKey: QueryKeys.jobPosts.show.id(jobPostId),
    queryFn: async () => {
      const { data } = await fetchJson(`/job-posts/${jobPostId}`, {
        schema: apiResourceSchema(jobPostSchema),
      });

      return data;
    },
    initialData: () => cachedJobPost?.data,
    initialDataUpdatedAt: () => cachedJobPost?.state.dataUpdatedAt,
    staleTime: 60 * 1000,
  });
};

export const useJobPost = (jobPostId: number) => useQuery(jobPostQueryOptions(jobPostId));
